/**
 * Compact number formatting for HUD chips (gold, gems) so large balances don't
 * blow out the header width and push other controls off-screen.
 *
 *   999      → "999"
 *   12_345   → "12.3K"
 *   1_500_000 → "1.5M"
 */
const compact = new Intl.NumberFormat('en', {
  notation: 'compact',
  maximumFractionDigits: 1,
});

export function formatCompact(value: number): string {
  if (!Number.isFinite(value)) return '0';
  // Keep small values exact (no "1K" surprise at 1000 boundaries below 10k feels
  // fine; under 1000 we always show the raw number).
  if (Math.abs(value) < 1000) return String(value);
  return compact.format(value);
}
